var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.source)?_c('img',{class:_vm.classes,attrs:{"src":_vm.source,"alt":_vm.alt}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }